import * as React from 'react';
import {Theme} from '@material-ui/core/styles';
import withStyles, {
  WithStyles,
  StyleRules,
  ClassNameMap
} from '@material-ui/core/styles/withStyles';
import DefinitionSection from '~common/form/definition-section';
import {Definition} from '~common/lib/types';
import {setValueAtPathWithOpts} from '~common/form/helper';
import Renderers from '~common/lib/renderers';
import {
  Select,
  MenuItem,
  FormControl,
  FormHelperText,
  InputLabel
} from '@material-ui/core';


// These are here to load the renderers
import CountEditor from '~dashboard/components/elements/count-editor';
import AggregationEditor from '~dashboard/components/elements/aggregation-editor';
// We _do have to registry them
CountEditor.register()
AggregationEditor.register()


type State = {
  config: any;
  configElementType: any;
  configComplete: boolean;

};

interface Props extends React.HTMLProps<HTMLDivElement> {
  classes: any;
  config: any;
  elementType: any;
  onConfigChange: (config: any, configComplete: boolean) => void;
}

const styles = (theme: Theme): StyleRules => ({
  modalContent: {
    width: 500
  },
  modalTitle: {
    padding: '0px 0px 20px 0px'
  },
  gridItem: {
    paddingBottom: '0px !important;',
    paddingTop: '0px !important;'
  },
  controlContainer: {
    width: '100%',
    padding: 0
  },
  inputLabel: {
    width: '100%'
  },
  dangerButton: {
    backgroundColor: '#af0202',
    '&:hover': {
      backgroundColor: '#5D0A0A !important'
    }
  },
  configViewArea: {
    paddingTop: 15,
    paddingBottom: 15
  },
  cardType: {
    width: 250
  }
});

class DashboardCardConfig extends React.Component<
  Props & WithStyles<keyof typeof styles>,
  State
> {
  constructor(props: Props) {
    super(props, {});
    console.log("props", props)
    this.state = {
      config: props.config || {elementType:"count"},
      configComplete: false,
      configElementType: {"key":"count", "uiAttributes":{"configRenderer":"CountConfigRenderer"}}
    };
  }

  componentWillReceiveProps(nextProps: Props) {
    this.setState({config: nextProps.config || {}});
  }


  handleConfigChange = (config:any) => {
    if(this.props.onConfigChange){
      this.props.onConfigChange(config)
    }
  };

  onCardTypeChange = (evt: any) => {
    const {config} = this.state
    if(evt.target.value){
      config.elementType = evt.target.value
    } else {
      config.elementType = null
    }
    this.setState({configElementType:elementTypesMap[evt.target.value], config: config});
  };


  render() {
    const {classes}: {classes: ClassNameMap} = this.props;
    const {results} = this.props;
    let {config, configElementType} = this.state;

    if (!config) {
      config = {};
    }

    var configView: any = null;

    console.log("configElementType", configElementType)

    let Renderer = Renderers.find(configElementType.uiAttributes.configRenderer);
    if (!Renderer) {
      Renderer = Renderers.find('[from selected element type]');
    }

    if (Renderer) {

      configView = (
        <Renderer
          classes={{}}
          element={config}
          elementType={configElementType}
          onConfigChange={this.handleConfigChange}
          results={results}
        />
      );

    } else {

      configView = (
        <div>Uh Oh!  Something has gone wrong</div>
      );

    }

    var allowGrouping:bool = false
    if(results.aggregationAttributes.grouping && results.aggregationAttributes.grouping.length > 0){
      allowGrouping = true
    }
  
    

    return (
      <div>
        {/* <div>Element Type Selector Here</div> */} {/* use this line instead of the line below when an element type selector is made*/}
        <div>

            <FormControl style={{marginLeft:10}}>
              <InputLabel
                shrink={true}
                htmlFor="configElementType">
                Card Type 
              </InputLabel>
              <Select
                //id={fieldDefinition.key}
                className={classes.cardType}
                name="configElementType"
                value={config.elementType}
                onChange={this.onCardTypeChange}>
                  <MenuItem
                    key="count"
                    value="count">
                    Count Card
                  </MenuItem>
                  { allowGrouping &&
                    <MenuItem
                      key="aggregation"
                      value="aggregation">
                      Grouped Card
                    </MenuItem>
                  }
              </Select>
              <FormHelperText ></FormHelperText>
            </FormControl>
        </div>
        <div className={classes.configViewArea}>{configView}</div>
      </div>
    );
  }
}

var elementTypesMap = {
  "count": {"key":"count", "uiAttributes":{"configRenderer":"CountConfigRenderer"}, "serverAttributes":{"elementAddChannel": "DashboardElements.CountElementAdd", "elementDeleteChannel": "DashboardElements.CountElementDelete", "elementUpdateChannel": "DashboardElements.CountElementUpdate", "elementFulfillmentChannel": "DashboardElements.CountElementFulfill"}},
  "aggregation": {"key":"aggregation", "uiAttributes":{"configRenderer":"AggregationConfigRenderer"}, "serverAttributes":{"elementAddChannel": "DashboardElements.AggregationElementAdd", "elementDeleteChannel": "DashboardElements.AggregationElementDelete", "elementUpdateChannel": "DashboardElements.AggregationElementUpdate", "elementFulfillmentChannel": "DashboardElements.AggregationElementFulfill"}}
}

export default withStyles(styles)(DashboardCardConfig);
